module.exports = __webpack_public_path__ + "media/opening-video.b5ee104f.webm";